/**
 * Prototype tab of the site detail page (figma sites only).
 *
 * The single editable home for a figma site's source: the site source card
 * (switch between the embedded Figma prototype and uploaded files, moved from
 * the Settings tab) and the full breakpoints editor (AeroFigmaSourceEditor,
 * also moved from Settings). The Overview tab keeps only a read-only summary
 * that links here, so the prototype is edited in exactly one place.
 */
import React from 'react';
import SiteSourceCard from '../SiteSourceCard';
import AeroFigmaSourceEditor from '../AeroFigmaSourceEditor';

function SitePrototypeTab({ user, site, fetchSite, fetchVersions, deploying, onDrop }) {
  const isFigmaSource = site.type === 'figma';

  return (
    <div className="aero-sites-settings">
      <SiteSourceCard
        user={user}
        site={site}
        fetchSite={fetchSite}
        fetchVersions={fetchVersions}
        deploying={deploying}
        onDrop={onDrop}
      />

      {/* Figma prototype editor: the full Figmafolio viewport experience,
          editable here and re-saved onto the same doc. Hidden while the site
          is temporarily flipped to uploaded files (the switch card above is
          the way back). */}
      {isFigmaSource && (
        <AeroFigmaSourceEditor
          user={user}
          site={site}
          fetchSite={fetchSite}
          fetchVersions={fetchVersions}
        />
      )}
    </div>
  );
}

export default SitePrototypeTab;
